import { fetchForms } from './fetch-forms';
import { loadTranslations, } from '../../services/load-translations';
import { getLocaleDataset, getAddressTemplates, getFieldInitialData, } from './load-forms';
import { getUserData } from './wix-code-api';
export const getInitialData = async ({ formIds, formKind, namespace, throwWhenFormMissing, language, localeDatasetLoader, httpClient, errorMonitor, additionalMetadata, wixCodeApi, errorHandler, environment, bi, appDefinitionId, }) => {
    const [formsById, translations, userData] = await Promise.all([
        fetchForms({
            formIds,
            formKind,
            namespace,
            httpClient,
            errorMonitor,
            throwWhenFormMissing,
            additionalMetadata,
            errorHandler,
            language,
        }),
        loadTranslations(language, errorMonitor),
        appDefinitionId && httpClient
            ? getUserData(wixCodeApi, { appDefinitionId, httpClient })
            : Promise.resolve(undefined),
    ]);
    const forms = Object.values(formsById).filter(Boolean);
    const [localeDataset, addressTemplates, fieldInitialData] = await Promise.all([
        getLocaleDataset({
            allForms: forms,
            language,
            localeDatasetLoader,
            errorMonitor,
        }),
        getAddressTemplates({
            forms,
            existingAddressTemplates: undefined,
            httpClient,
            errorHandler,
            excludeEcomAddress: true,
        }),
        getFieldInitialData({
            forms,
            httpClient,
            errorHandler,
            wixCodeApi,
            environment,
            bi,
        }),
    ]);
    return {
        formsById,
        translations,
        localeDataset,
        addressTemplates,
        fieldInitialData,
        userData,
    };
};
//# sourceMappingURL=get-initial-data.js.map